// src/styles/AuthStyles.js
import styled from 'styled-components';

export const AuthContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 90vh; /* Changed from 90vh to 100vh */
  padding: 20px; /* Added padding for smaller screens */
`;

export const AuthBox = styled.div`
  background: #ffffff;
  padding: 40px 30px; /* Adjusted padding for better spacing */
  border-radius: 10px; /* Increased border-radius for a smoother look */
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1); /* Enhanced box-shadow for depth */
  width: 400px;
  max-width: 100%; /* Ensures the box doesn't exceed viewport width */
  
  @media (max-width: 480px) {
    width: 100%;
    padding: 30px 20px; /* Adjusted padding for smaller screens */
  }
`;

export const Title = styled.h2`
  margin-bottom: 25px; /* Reduced margin for tighter spacing */
  text-align: center;
  color: #333333;
  font-size: 24px; /* Increased font size for better visibility */
  font-weight: 600; /* Made the title slightly bolder */
`;

export const InputField = styled.input`
  width: 90%; /* Changed from 92% to 100% for full-width inputs */
  padding: 14px 18px; /* Increased padding for better touch targets */
  margin-bottom: 18px; /* Adjusted margin for consistent spacing */
  border: 1px solid #cccccc;
  border-radius: 6px; /* Slightly larger border-radius */
  font-size: 16px;
  transition: border-color 0.3s ease; /* Smooth transition for focus state */
  
  &:focus {
    border-color: #007bff;
    outline: none;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5); /* Added subtle shadow on focus */
  }
`;

export const Button = styled.button`
  width: 100%;
  padding: 14px 18px; /* Increased padding for better clickability */
  background: #007bff;
  color: #ffffff;
  border: none;
  border-radius: 6px; /* Consistent border-radius with InputField */
  font-size: 16px;
  cursor: pointer;
  transition: background 0.3s ease; /* Smooth transition for hover state */
  
  &:hover {
    background: #0056b3;
  }
  
  &:disabled {
    background: #cccccc;
    cursor: not-allowed;
  }
`;

export const ErrorMessage = styled.p`
  color: #d9534f; /* Changed to a more standard error color */
  margin-bottom: 20px;
  text-align: center;
  font-weight: 500; /* Slightly bolder text for emphasis */
`;

export const SuccessMessage = styled.p`
  color: #28a745; /* Standard success color */
  margin-bottom: 20px;
  text-align: center;
  font-weight: 500;
`;

export const LinkText = styled.p`
  margin-top: 20px;
  text-align: center;
  color: #007bff;
  font-size: 14px; /* Adjusted font size for links */
  
  a {
    color: #007bff;
    text-decoration: none;
    font-weight: 500;
    
    &:hover {
      text-decoration: underline;
    }
  }
`;
